<template>
  <q-form ref="formAttendaceClock">
    <section class="form-section">
      <div class="col-12 row title-page-form">Informações finais</div>

      <div class="col-12 row q-mt-sm">
        <label>Insira os horários de início e conclusão do atendimento.</label>
      </div>
      <div class="col-12 q-mt-lg">
        <label for="start">Início</label>
        <q-input
          id="start"
          v-model="contract.initialTime"
          bg-color="white"
          class="col-12 q-mt-sm"
          color="red-9"
          type="time"
          dense
          placeholder="00:00"
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          @update:model-value="validateTime"
          lazy-rules
        />
      </div>
      <div class="col-12 q-mt-lg">
        <label for="conclusion_time">Conclusão</label>
        <q-input
          id="conclusion_time"
          v-model="contract.conclusionTime"
          bg-color="white"
          class="col-12 q-mt-sm"
          color="red-9"
          placeholder="00:00"
          type="time"
          dense
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          @update:model-value="validateTime"
          lazy-rules
          :disable="!contract.initialTime"
        />
      </div>
    </section>
  </q-form>
</template>

<script>
  import { validateConclusionTime } from "@/helpers/conclusionTimeHelper";
import { timeToMinutes } from "@/helpers/timeToMinutesHelper";
import { ref } from "vue";

  export default {
    name: "AttendanceClock",
    props: {
      contract: Object,
    },
    setup(props) {
      let formAttendaceClock = ref(null);

      async function validateForm() {
        return await formAttendaceClock.value.validate();
      }

      const validateTime = (val) => {
        if (val && props.contract.initialTime && val === props.contract.conclusionTime) {
          const startTimeInMinutes = timeToMinutes(props.contract.initialTime);
          const endTimeInMinutes = timeToMinutes(props.contract.conclusionTime);

          const isValid = validateConclusionTime(
            startTimeInMinutes,
            endTimeInMinutes
          );

          !isValid ? (props.contract.conclusionTime = "") : null;
        }
      };

      return {
        formAttendaceClock,
        validateForm,
        validateTime,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .form-section {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  label {
    font-weight: bold;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.4);
  }

  .title-page-form {
    font-weight: bold;
    font-size: 18px;
    line-height: 19px;
    text-transform: uppercase;
    color: #e2262d;
  }
</style>
